import { faGift } from "@fortawesome/pro-regular-svg-icons/faGift";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const Gift: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faGift} {...props} />;
};
